import { stringify } from 'qs';

export function getQueryString(parameters: Record<string, unknown> | null | undefined): string {
	if (!parameters) {
		return '';
	}

	const filteredParams: { [key: string]: unknown } = {};
	for (const [ key, value ] of Object.entries(parameters)) {
		if (value === undefined || value === null || value === '') {
			continue;
		}

		filteredParams[ key ] = value;
	}

	return stringify(filteredParams, { indices: false });
}
